import { render, staticRenderFns } from "./DivisionManage.vue?vue&type=template&id=62deadaa&scoped=true&"
import script from "./DivisionManage.vue?vue&type=script&lang=js&"
export * from "./DivisionManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62deadaa",
  null
  
)

export default component.exports